import React from "react";
import "./Machine.css";

import mcm from "../../../Gallery/ServicesImages/M3/mac.jpg";
import { useNavigate } from "react-router-dom";

function Machining() {

  const navigate = useNavigate()
  return (
    <section className="machining-section">

      <div className="machining-container">

        {/* LEFT — IMAGE */}
        <div className="machining-image">
          <img src={mcm} alt="Machining Facility" />
        </div>

        {/* RIGHT — CONTENT */}
        <div className="machining-content">

          <h1>MACHINING</h1>
          <div className="underline"></div>

          <p>
            Our machining facilities are equipped with high-precision CNC, VMC, 
            and multi-axis machining centers capable of handling complex and 
            highly demanding jobs. With advanced equipment such as Mazak Integrex,
            Haas milling machines, and 5-axis Mazak Nexus, we deliver perfect 
            accuracy and repeatability for every component.
          </p>

          <p>
            From prototype machining to full-scale production, our in-house 
            capabilities ensure faster turnaround times, superior tolerances, 
            and enhanced surface finishing. Even intricate geometries and 
            challenging materials are machined with exceptional precision.
          </p>

          <button className="machining-btn" onClick={() => navigate("/contact")}>Contact</button>

        </div>

      </div>

    </section>
  );
}

export default Machining;
